import { Box, Typography, useTheme } from "@mui/material";
import { ArrowDropUp, ArrowDropDown } from "@mui/icons-material";
import React from "react";

interface MetricCardProps {
    icon: React.ReactNode;
    label: string;
    value: string | number;
    change: number;
    percentage: string;
    color?: string;
}


export const MetricCard = ({
    icon,
    label,
    value,
    change,
    percentage,
    color,
}: MetricCardProps) => {
    const isPositive = change >= 0;
    const trendColor = color ?? (isPositive ? "#06D6A0" : "#C3423F");

    return (
        <Box
            sx={{
                flex: 1,
                minWidth: 220,
                maxWidth: 250,
                p: 2,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
            }}
        >
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Typography variant="h5" fontWeight={700}>
                    {value}
                </Typography>
                <Box sx={{ fontSize: 24, color: "#fc6a2f" }}>{icon}</Box>
            </Box>
            <Typography color="textSecondary" sx={{ mt: 0.5 }}>
                {label}
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", mt: 1, color: trendColor }}>
                {isPositive ? <ArrowDropUp /> : <ArrowDropDown />}
                <Typography variant="body2" fontWeight={500} mr={0.5}>
                    {Math.abs(change)}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                    {percentage}
                </Typography>
            </Box>
        </Box>
    );
};